import React from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { IsShowOrderLog } from "../../utils";

function RestrictOrderLog(props) {
  if (IsShowOrderLog()) return props.children;
  return <NotAccess />;
}

export default RestrictOrderLog;
